import classNames from 'classnames';

import InfoIcon from '@/components/global/InfoIcon';
import { formatNumberAsThousandCurrency, thousandFormat } from '@/helpers/number';
import { StatItemType } from '@/models/globalModels';

import styles from './StatItem.module.scss';

const StatItem = ({ className, currency, description, icon, money, name, points, type }: StatItemType) => {
  const getValueFormatted = (): string => {
    const text = [];

    if (typeof money === 'number' && money > 0) {
      const moneyParsed = formatNumberAsThousandCurrency(money, currency);
      text.push(moneyParsed);
    }

    if (typeof points === 'number' && points > 0) {
      text.push(thousandFormat(points));
    }

    return text.length ? text.join(' / ') : '0';
  };

  return (
    <div className={classNames(styles.content, styles[type], className)}>
      <span className={classNames(`icon-${icon}`, styles.icon)} />
      <div className={classNames('f-roboto-regular text-capitalize', styles.name)}>{name}</div>
      <div className={classNames('f-roboto-light', styles.value)}>{getValueFormatted()}</div>
      <InfoIcon className={styles.tooltip} tooltip={description} />
    </div>
  );
};

export default StatItem;
